const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  // 新增tagsView
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js